<template>
    <section>
        <div class="swiper-box">
            <div class="swiper-main">
                <swiper v-if="slides.length > 1" :options="swiperOption" style="background: #000">
                    <swiper-slide v-for="(v, k) in slides" :key="k" class="swiper-slide" :style="`background-image: url(${v.thumb})`">
                        <div @click="redirect(v)" style="width: 100%;height: 100%"></div>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
                <div v-if="slides.length === 1" @click="redirect(slides[0])" class="swiper-slide" :style="`background-image: url(${slides[0].thumb})`"></div>
            </div>
        </div>
        <div class="video-box df jcsb">
            <div v-for="v in videos" :key="v.id"  @click="redirect(v)" class="video-link">
                <div class="video-thumb" :style="`background-image: url(${v.thumb})`">
                    <div v-if="v.type !== 5" class="video-meta">
                        <div class="video-meta-play">
                            <i class="icon-play"></i>{{$view(v.views)}}
                        </div>
                        <i class="icon-comment"></i>{{v.comments}}
                    </div>
                </div>
                <div class="video-title">{{v.title}}</div>
            </div>
        </div>
        <a v-show="!isLoading" class="empty download" href="http://a.app.qq.com/o/simple.jsp?pkgname=com.vhiphop.app">查看全部视频，请下载 Vhiphop 客户端 >></a>
    </section>
</template>

<script>
    export default {
        data: () => ({
            swiperOption: {
                autoplay: true,
                loop : true,
                pagination: {
                    el: '.swiper-pagination'
                },
            },
            slides: [],
            videos: [],
            isLoading: true,
        }),
        methods: {
            redirect(v) {
                switch(v.type) {
                    case 1: this.$router.push(`/videos/${v.id}`);break;
                    case 2: this.$router.push(`/contests/${v.id}`);break;
                    case 3: this.$router.push(`/info/${v.id}`);break;
                    default: window.open(v.link);
                }
            },
        },
        async beforeMount() {
            const {api} = this;

            await Promise.all([
                api.get('home/slides/app').then(e => this.slides = e),
                api.get('videos').then(e => this.videos = e)
            ]).catch(this.err);
            this.isLoading = false;
            this.$share();
        }
    }
</script>

<style scoped>
    @import '../../../static/css/home/home.css';
    @import '../../../static/css/home/video-list.css';
</style>


// WEBPACK FOOTER //
// src/components/home/Home.vue